import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import Loader from 'components/atoms/Loader';
import routes from './routes';

function Router() {
  const ErrorLayout = lazy(() => import('templates/Error'));
  const BankAccountLayout = lazy(() => import('templates/BankAccount'));
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {routes.map((route, i) => {
          const Page = lazy(() => import(`../${route.component}`));
          const layout = route.error ? (
            <ErrorLayout title={route.title} />
          ) : (
            <BankAccountLayout title={route.title} path={route.path} />
          );

          return (
            <Route key={i} element={layout}>
              <Route path={route.path} element={<Page />} />
            </Route>
          );
        })}
      </Routes>
    </Suspense>
  );
}

export default Router;
